<template>
  <div class="container">
    <h2>Résumé du projet {{ project.name }} de {{ project.clientName }}</h2>

    <table class="table table-striped mt-3">
      <thead>
        <tr>
          <th>Type</th>
          <th>Minimum</th>
          <th>Maximum</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Programmation</td>
          <td>{{ totalProgMin }}</td>
          <td>{{ totalProgMax }}</td>
        </tr>
        <tr>
          <td>Analyse</td>
          <td>{{ totalAnalysisMin }}</td>
          <td>{{ totalAnalysisMax }}</td>
        </tr>
        <tr>
          <td>QA</td>
          <td>{{ totalQaMin }}</td>
          <td>{{ totalQaMax }}</td>
        </tr>
        <tr>
          <td>Gestion technique</td>
          <td>{{ totalGestionTechMin }}</td>
          <td>{{ totalGestionTechMax }}</td>
        </tr>
        <tr>
          <td>Post-QA Dev</td>
          <td>{{ totalPostQaDevMin }}</td>
          <td>{{ totalPostQaDevMax }}</td>
        </tr>
        <tr>
          <td>Support aux tests client</td>
          <td>{{ supportTestClientMin }}</td>
          <td>{{ supportTestClientMax }}</td>
        </tr>
        <tr>
          <td>Déploiement</td>
          <td>
            <div class="form-group">
              <input
                class="input-sm col-sm-3"
                type="number"
                v-model="tempsDeploiementMin"
                @keyup="setDeploymentMin(tempsDeploiementMin)"
              >
            </div>
          </td>

          <td>
            <div class="form-group">
              <input
                class="input-sm col-sm-3"
                type="number"
                v-model="tempsDeploiementMax"
                @keyup="setDeploymentMax(tempsDeploiementMax)"
              >
            </div>
          </td>
        </tr>
      <tr>
          <td>Gestion de projet</td>
          <td>
            <div class="form-group">
              <input
                class="input-sm col-sm-3"
                type="number"
                v-model="gestionProjetMin"
                @keyup="setGestionMin(gestionProjetMin)"
              >
            </div>
          </td>

          <td>
            <div class="form-group">
              <input
                class="input-sm col-sm-3"
                type="number"
                v-model="gestionProjetMax"
                @keyup="setGestionMax(gestionProjetMax)"
              >
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <download-excel :data="resume" :fields="fieldsExcelDoc" :name="project.name">
      <button type="submit" class="btn btn-primary btn-lg float-right">Exporter en document excel</button>
    </download-excel>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import KezInput from "@/components/_forms/KezInput";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";

export default {
  components: {
    KezInput,
    KezConfirmModal
  },
  data() {
    return {
      isAdd: true,
      openModalDelete: false,
      selectedProject: null,
      isEdit: false,
      fieldsExcelDoc: {
        Type: "Type",
        Minimum: "Minimum",
        Maximum: "Maximum"
      },
      tempsDeploiementMin: 0,
      tempsDeploiementMax: 0,
      gestionProjetMin: 0,
      gestionProjetMax: 0
    };
  },
  computed: {
    ...mapState("projects", ["project"]),
    ...mapState("projectTasks", ["projectTasks"]),
    ...mapGetters("resume", [
      "calculTotalProgMin",
      "calculTotalProgMax",
      "calculTotalAnalysisMin",
      "calculTotalAnalysisMax",
      "calculTotalGestionTechMin",
      "calculTotalGestionTechMax",
      "calculTotalQaMin",
      "calculTotalQaMax",
      "calculTotalPostQaDevMin",
      "calculTotalPostQaDevMax",
      "calculSupportTestClientMin",
      "calculSupportTestClientMax"
    ]),
    ...mapGetters("parameters", ["getIndex"]),
    ...mapState("resume", ["resume", "index"]),
    ...mapActions("resume", ["setIndex"]),
    totalProgMin() {
      return this.calculTotalProgMin(this.projectTasks);
    },
    totalProgMax() {
      return this.calculTotalProgMax(this.projectTasks);
    },
    totalGestionTechMin() {
      return this.calculTotalGestionTechMin(this.projectTasks);
    },
    totalGestionTechMax() {
      return this.calculTotalGestionTechMax(this.projectTasks);
    },
    totalAnalysisMin() {
      return this.calculTotalAnalysisMin(this.projectTasks);
    },
    totalAnalysisMax() {
      return this.calculTotalAnalysisMax(this.projectTasks);
    },
    totalQaMin() {
      return this.calculTotalQaMin(this.projectTasks);
    },
    totalQaMax() {
      return this.calculTotalQaMax(this.projectTasks);
    },
    totalPostQaDevMin() {
      return this.calculTotalPostQaDevMin(this.projectTasks);
    },
    totalPostQaDevMax() {
      return this.calculTotalPostQaDevMax(this.projectTasks);
    },
    supportTestClientMin() {
      return this.calculSupportTestClientMin(this.projectTasks);
    },
    supportTestClientMax() {
      return this.calculSupportTestClientMax(this.projectTasks);
    },
    totalDeploiementMin() {
      return tempsDeploiementMin;
    },
    totalDeploiementMax() {
      return tempsDeploiementMax;
    },
    getThisIndex(taskName) {
      return this.getIndex(taskName);
    }
  },
  watch: {
    projectTasks: {
      handler(newVal) {
        if (newVal && this.projectTasks.length > 0) {
          this.$store.dispatch("resume/getDataForExcel", this.$route.query.id);
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("projects/get", this.$route.query.id);
    this.$store.dispatch("projectTasks/getList", this.$route.query.id);
  },
  methods: {
    setDeploymentMin(temps) {
      this.$store.commit("resume/setDeploiementMin", temps);
      this.$store.dispatch("resume/getDataForExcel");
    },
    setDeploymentMax(temps) {
      this.$store.commit("resume/setDeploiementMax", temps);
      this.$store.dispatch("resume/getDataForExcel");
    },
    setGestionMin(temps) {
      this.$store.commit("resume/setGestionMin", temps);
      this.$store.dispatch("resume/getDataForExcel");
    },
    setGestionMax(temps) {
      this.$store.commit("resume/setGestionMax", temps);
      this.$store.dispatch("resume/getDataForExcel");
    }
  }
};
</script>